import React from "react";
import { Chip } from "primereact/chip";
import "./index.scss";
const FilterChip = ({ filterData, removeFilter }) => {
  const selectedItems = Object.values(filterData || {}).filter(
    (value) =>
      ![
        "category",
        "service_line",
        "entities",
        "year",
        "request_type",
      ].includes(value?.id),
  );

  return (
    <div className="filter-chip-container flex gap-2 flex-wrap align-items-center">
      {selectedItems?.length ? `Filters (${selectedItems?.length})` : null}
      {selectedItems?.map((item) => (
        <Chip
          key={item.id}
          label={
            <span className="flex align-items-center gap-2">
              <span>{item.name}</span>
              <i
                className="pi pi-times-circle cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  removeFilter(item.id);
                }}
              />
            </span>
          }
          removable={false}
        />
      ))}
    </div>
  );
};

export default FilterChip;
